import { FC } from "react";

import Button from "apps/website/components/base/Button/Button";

const SkipToContent: FC = () => (
  <Button component="SkipToContent" to="#main" className="absolute top-4 left-4 z-[100] -translate-x-[200%] focus:translate-x-0 " size="fit-content">Skip to content</Button>
);

export default SkipToContent;
